import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { NAMES } from 'cio/utils/ad-audiences';

export default class SetupRoute extends Route {
  @service store;

  crumb() {
    let { type } = this.paramsFor('integrations.audiences.type');

    return {
      name: NAMES[type],
      path: 'integrations.audiences.type',
      model: type,
    };
  }

  async model() {
    let { type } = this.paramsFor('integrations.audiences.type');
    let credentials = await this.store.findAll('audience-credential');

    return {
      type,
      credential: credentials.find((credential) => credential.type === type),
    };
  }

  redirect({ credential, type }) {
    if (credential) {
      this.router.transitionTo('integrations.audiences.type.settings', { type });
    }
  }
}
